import formatSupportCaseStatus from './formatSupportCaseStatusUtil';

export default formatSupportCaseStatus;
